import { AxiosRequestConfig } from 'axios';

export type IServerResponse<T> = {
  success: boolean;
  message: null | string;
  data: null | T;
  statusCode: number;
  errorResponse: any;
};

export type HeaderOptions = {
  token: string;
} & HeadersInit;

export type RequestOptions = AxiosRequestConfig<any> & {
  params?: object;
  /** A Headers object, an object literal, or an array of two-item arrays to set request's headers. */
  headers?: HeaderOptions;
  /** An AbortSignal to set request's signal. Allows you to abort one or more Web requests as and when desired. */
  signal?: AbortSignal | null;
};

export type HttpBaseApiWrapper = {
  get: <T>(relativeUrl: string, options?: RequestOptions) => Promise<T>;
  post: <T>(
    relativeUrl: string,
    body?: object,
    options?: RequestOptions
  ) => Promise<T>;
  put: <T>(
    relativeUrl: string,
    body?: object,
    options?: RequestOptions
  ) => Promise<T>;
  patch: <T>(
    relativeUrl: string,
    body?: object,
    options?: RequestOptions
  ) => Promise<T>;
  delete: <T>(
    relativeUrl: string,
    body?: object,
    options?: RequestOptions
  ) => Promise<T>;
};

// TODO: Switch to the right build!!!!!!!
const baseUrl = process.env.REACT_APP_BASE_URL;
const apiVersion = process.env.REACT_APP_API_VERSION;

export const endpointRegistry = {
  varisht: `${baseUrl}/${apiVersion}`,
  auth: `${baseUrl}/${apiVersion}/authenticate`,
  users: `${baseUrl}/${apiVersion}/users`,
  students: `${baseUrl}/${apiVersion}/students`,
  events: `${baseUrl}/${apiVersion}/events`,
  finance: `${baseUrl}/${apiVersion}/finance`,
  staff: `${baseUrl}/${apiVersion}/staff`,
  profile: `${baseUrl}/${apiVersion}/profile`,
  academic: `${baseUrl}/${apiVersion}/academics`,
  settings: `${baseUrl}/${apiVersion}/settings`,
  admin: `${baseUrl}/${apiVersion}/admin`,
  communication: `${baseUrl}/${apiVersion}/messages`,
  analytics: `${baseUrl}/${apiVersion}/analytics`,
  dashboard: `${baseUrl}/${apiVersion}/dashboard`,
  documents: `${baseUrl}/${apiVersion}/documents`,
  score: `${baseUrl}/${apiVersion}/score`,
  rbac: `${baseUrl}/${apiVersion}/rbac`,
  branding: `${baseUrl}/${apiVersion}/branding`,
  inventory: `${baseUrl}/${apiVersion}/inventory`,
};

export type HttpBaseApi = Record<
  keyof typeof endpointRegistry,
  HttpBaseApiWrapper
> &
  HttpBaseApiWrapper;

export interface IApiService {
  httpAPI: HttpBaseApi;
  endpoint?: string;
}
export type TReactQueryError<T> = {
  // TODO: Remove this
  response?: {
    data: T;
    status: string | number;
  };
};
